import { useMutation } from '@tanstack/react-query';
import { ActivityEndpoints } from '../../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../../lib/axios';

export const useSavePrimaryTravellerIdMutation = () => {
  return useMutation({
    mutationFn: async (vars: { primaryTravellerId: number; activityId: number }) => {
      await getAxios().post(ActivityEndpoints.travellersAndPaymentInfo.savePrimaryTravellerId(), {
        travellerId: vars.primaryTravellerId,
        activityId: vars.activityId
      });
    }
  });
};
